import { 
    OPCIONES_MENU,
    VER_CUENTAS,
    OBTENER_USUARIOS,
    ELIMINAR_USUARIO,
    REINICIAR_BPPL_STATE
} from '../../types';

export default (state, action) => {
    switch(action.type){
        case OPCIONES_MENU:
            return {
                ...state,
                vistamenu: action.payload
            }
        case VER_CUENTAS:
            return {
                ...state,
                vercuentas: action.payload
            }
        case OBTENER_USUARIOS:
            return {
                ...state,
                cuentas: action.payload
            }
        case ELIMINAR_USUARIO:
            return {
                ...state,
                cuentas: state.cuentas.filter(cuenta => cuenta._id !== action.payload)
            }
        case REINICIAR_BPPL_STATE:
            return {
                ...state,
                cuentas: [],
                vistamenu: '',
                vercuentas: false
            }
        default:
            return state;
    }
}